import React, { Component } from 'react';
import Drawer from 'material-ui/Drawer';
import IconButton from 'material-ui/IconButton';
import { connect } from 'react-redux';
import {
  changePassword, resendVerificationCode, signOut, updateUserAttributes,
  verifyEmailAddress,
} from 'util/user-manager';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { createNotification } from 'util/util';
import Button from 'material-ui/Button';
import { uploadProfileImage } from 'util/fileManager';
import { persistConfig } from 'store/index';
import { purgeStoredState } from 'redux-persist';
import * as CONST from 'util/app-constants';

class ProfileAndSettings extends Component {
    imageUrl;
    constructor(props) {
      super(props);

      const defaultImage = this.props.userAttributes.picture || CONST.DEFAULT_PROFILE_IMG;

      this.state = {
        drawerState: false,
        username: this.props.username,
        name: this.props.userAttributes.nickname,
        showNameInput: false,
        position: this.props.userAttributes['custom:position'],
        showPositionInput: false,
        team: this.props.userAttributes['custom:team'],
        showTeamInput: false,
        nameInput: false,
        content: 'default',
        oldPassword: null,
        newPassword: null,
        confirmPassword: null,
        verifyEmail: !this.props.data.email_verified,
        verificationCode: null,
        profileImageUrl: null,
        imageUrl: defaultImage,
        phoneNumber: '+61428765435',
        email: 'jalderson@nbnco.com.au',
      };

      this.oldPasswordChange.bind(this);
      this.newPasswordChange.bind(this);
      this.confirmPasswordChange.bind(this);
      this.updateAttribute.bind(this);
      this.positionChange.bind(this);
      this.nameChange.bind(this);
    }

    componentDidMount() {
      this.setState({ verifyEmail: !this.props.data.email_verified, phoneNumber: this.props.data.phone_number, email: this.props.data.email });
    }

    onToggleDrawer() {
      this.setState({
        drawerState: !this.state.drawerState,
      });
    }

    updateProfile = () => {
      this.setState({
        content: 'default',
      });
    };

    nameChange = (e) => {
      this.setState({
        name: e.target.value,
      });
    };

    positionChange = (e) => {
      this.setState({
        position: e.target.value,
      });
    };

    teamChange = (e) => {
      this.setState({
        team: e.target.value,
      });
    };

    oldPasswordChange = (e) => {
      this.setState({
        oldPassword: e.target.value,
      });
    };

    newPasswordChange = (e) => {
      this.setState({
        newPassword: e.target.value,
      });
    };

    confirmPasswordChange = (e) => {
      this.setState({
        confirmPassword: e.target.value,
      });
    };

    onVerificationCodeChange = (e) => {
      this.setState({
        verificationCode: e.target.value,
      });
    };

    onNameSaveClick = () => {
      // this.props.updateUsername(this.state.username);
      this.setState({
        showNameInput: false,
      });
    };

    onPositionSaveClick = () => {
      // this.props.updateUsername(this.state.username);
      this.setState({
        showPositionInput: false,
      });
    };

    onTeamSaveClick = () => {
      // this.props.updateUsername(this.state.username);
      this.setState({
        showTeamInput: false,
      });
    };

    changePasswordWrapper = () => {
      changePassword(this.state.oldPassword, this.state.newPassword, this.props.userData)
        .then(() => {
          createNotification('Password change successful.', 'Success', 'Success');
          this.setState({ content: 'default' });
        }, (error) => {
          NotificationManager.error(error.message);
        });
    };

    signUserOut = () => {
      signOut()
        .then(() => {
          this.props.signOut();
          this.props.setDefaultTheme();


          const body = $('#body');
          body.removeClass();
          body.addClass(this.props.themeColor);
          purgeStoredState(persistConfig);
        }, () => {
          this.props.signOut();
          this.props.setDefaultTheme();


          const body = $('#body');
          body.removeClass();
          body.addClass(this.props.themeColor);
          purgeStoredState(persistConfig);
        });
    };

    sideNavJSX = () => {
      return (
        <ul className="profile-side-nav p-3">
          <h1>Profile</h1>
          <li onClick={this.updateProfile}>
                    Profile Details
          </li>
          <li onClick={() => {
                    this.setState({ content: 'changePassword' });
                }}
          >
                    Change Password
          </li>
          <li onClick={() => {
                    this.setState({ content: 'changeProfileImage' });
                }}
          >
                    Change Profile Photo
          </li>
          {this.state.verifyEmail ? (<li onClick={() => {
                    this.setState({ content: 'confirmEmail' });
                }}
          >
                    Verify Email Address
          </li>) : ''}
          <li>
                    Create Teams
          </li>
          <li>
                    Create New Report
          </li>
          <li>
                    Log an Incident
          </li>
          <li>
                    Provide Feedback
          </li>
          <li onClick={this.signUserOut}>
                    SignOut
          </li>

        </ul>
      );
    };

    handleKeyPress = (e) => {
      if (e.key === 'Enter') {
        this.onSaveClick();
      }
    };

    updatePassword = () => {
      if (this.state.newPassword !== this.state.confirmPassword) {
        createNotification('Passwords do not match.', 'Error', 'Error');
      }
      else {
        this.changePasswordWrapper();
      }
    };

    verifyEmail = () => {
      verifyEmailAddress(this.state.verificationCode)
        .then(() => {
          createNotification('Email verified.', 'Success', 'Success');
          // let loginData = this.props.data;
          // loginData.idToken.email_verified = true;
          // this.props.updateVerifyEmailField(loginData);
          this.setState({ content: 'default' });
        }, (error) => {
          createNotification(error.message, 'Error', 'Error');
        });
    };

    resendVerification = () => {
      resendVerificationCode()
        .then(() => {
          createNotification('Verification code resent successful', 'Success', 'Success');
        }, () => {
          createNotification('There was an error. Please try again', 'Error', 'Error');
        });
    };

    updateAttribute = (attibuteList) => {
      updateUserAttributes(attibuteList)
        .then(() => {
          const data = this.props.userAttributes;
          if (attibuteList[0].Name === 'nickname') {
            createNotification('Attribute update successful.', 'Success', 'Success');
            data.nickname = this.state.name;
            this.props.profileDetailsUpdate(data);
          }
          if (attibuteList[0].Name === 'custom:position') {
            createNotification('Attribute update successful.', 'Success', 'Success');
            data['custom:position'] = this.state.position;
            this.props.profileDetailsUpdate(data);
          }
          if (attibuteList[0].Name === 'custom:team') {
            createNotification('Attribute update successful.', 'Success', 'Success');
            data['custom:team'] = this.state.team;
            this.props.profileDetailsUpdate(data);
          }
          if (attibuteList[0].Name === 'picture') {
            createNotification('Image upload successful.', 'Success', 'Success');
            data.picture = this.imageUrl;
            this.props.profileDetailsUpdate(data);
            this.setState({
              imageUrl: this.imageUrl,
            });
          }
        }, (error) => {
          createNotification(error.message, 'Error', 'Error');
        });
    };

    toggleName = () => {
      this.setState({
        showNameInput: !this.state.showNameInput,
      });
    };

    togglePosition = () => {
      this.setState({
        showPositionInput: !this.state.showPositionInput,
      });
    };

    toggleTeam = () => {
      this.setState({
        showTeamInput: !this.state.showTeamInput,
      });
    };

    profileDetailsUpdate = () => {

    };

    uploadProfileImage = () => {
      const fileChooser = document.getElementById('file-chooser');
      const imageExtension = fileChooser.files[0].name.split('.').pop().toLowerCase();
      uploadProfileImage(fileChooser, `${this.props.username.toLowerCase()}.${imageExtension}`)
        .then(() => {
          this.imageUrl = `http://${CONST.BUCKET_NAME}.s3.amazonaws.com/profile/${this.props.username.toLowerCase()}.${imageExtension}`;
          this.updateAttribute([{ Name: 'picture', Value: this.imageUrl }]);
        }, (err) => {
          createNotification(err.message, 'Error', 'Error');
        });
    }

    content = () => {
      if (this.state.content === 'default') {
        return (
          <div className="col-lg-12">
            <div className="row">
              <div className="col-lg-3 profile-img image-size">
                <img className="w-75" src={this.state.imageUrl} onError={(e) => { e.target.src = CONST.DEFAULT_PROFILE_IMG; }} />
              </div>
              <div className="col-lg-9 profile-detail pt-4">
                <table className="table">
                  <tbody>
                    <tr>
                      <td>Name:</td>
                      <td>{this.state.showNameInput ?
                        <input
                          onChange={(e) => {
                                            this.nameChange(e);
                                        }}
                          value={this.state.name}
                        /> : this.state.name}</td>
                      <td>{this.state.showNameInput ?
                        <span><i
                          className="fa fa-check fa-2x text-green mr-2"
                          aria-hidden="true"
                          onClick={() => {
                                            this.updateAttribute([{ Name: 'nickname', Value: this.state.name }]);
                                            this.onNameSaveClick();
                                        }}
                        /><i onClick={() => { this.setState({ showNameInput: false }); }} className="fa fa-times fa-2x text-red" aria-hidden="true" /></span> : ''}{this.state.showNameInput ? '' :
                        <i onClick={this.toggleName} className="ml-5 fa fa-edit" />}</td>
                    </tr>
                    <tr>
                      <td>Username:</td>
                      <td>{this.state.username}</td>
                      <td />
                    </tr>
                    <tr>
                      <td>Position:</td>
                      <td>{this.state.showPositionInput ?
                        <input
                          onChange={(e) => {
                                            this.positionChange(e);
                                        }}
                          value={this.state.position}
                        /> : this.state.position}</td>
                      <td>{this.state.showPositionInput ?
                        <span><i
                          className="fa fa-check fa-2x text-green mr-2"
                          aria-hidden="true"
                          onClick={() => {
                                            this.updateAttribute([{
                                                Name: 'custom:position',
                                                Value: this.state.position,
                                            }]);
                                            this.onPositionSaveClick();
                                        }}
                        /><i onClick={() => { this.setState({ showPositionInput: false }); }} className="fa fa-times fa-2x text-red" aria-hidden="true" /></span> : ''}{this.state.showPositionInput ? '' :
                        <i onClick={this.togglePosition} className="ml-5 fa fa-edit" />}</td>
                      {/* Senior Network Operations Specialist */}
                    </tr>
                    <tr>
                      <td>Team:</td>
                      <td>{this.state.showTeamInput ?
                        <input
                          onChange={(e) => {
                                            this.teamChange(e);
                                        }}
                          value={this.state.team}
                        /> : this.state.team}</td>
                      <td>{this.state.showTeamInput ?
                        <span><i
                          className="fa fa-check fa-2x text-green mr-2"
                          aria-hidden="true"
                          onClick={() => {
                                            this.updateAttribute([{ Name: 'custom:team', Value: this.state.team }]);
                                            this.onTeamSaveClick();
                                        }}
                        /><i onClick={() => { this.setState({ showTeamInput: false }); }} className="fa fa-times fa-2x text-red" aria-hidden="true" /></span> : ''}{this.state.showTeamInput ? '' :
                        <i onClick={this.toggleTeam} className="ml-5 fa fa-edit" />}</td>
                      {/* NOC Operations */}
                    </tr>
                    <tr>
                      <td>Mobile Number:</td>
                      <td>{this.state.phoneNumber}</td>
                      <td />
                    </tr>
                    <tr>
                      <td>Email Address:</td>
                      <td>{this.state.email}</td>
                      <td />
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
      }

      if (this.state.content === 'changePassword') {
        return (
          <div className="profile-detail">
            <table className="table">
              <tbody>
                <tr>
                  <td>Old Password</td>
                  <td><input
                    type="password"
                    onChange={(e) => {
                                this.oldPasswordChange(e);
                            }}
                  /></td>
                </tr>
                <tr>
                  <td>New password</td>
                  <td><input
                    type="password"
                    onChange={(e) => {
                                this.newPasswordChange(e);
                            }}
                  /></td>
                </tr>
                <tr>
                  <td>Confirm password</td>
                  <td><input
                    type="password"
                    onChange={(e) => {
                                this.confirmPasswordChange(e);
                            }}
                  /></td>
                </tr>
                <tr>
                  <td />
                  <td>
                    <Button onClick={this.updatePassword} variant="raised" className="jr-btn bg-success text-white">Update Password
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      }

      if (this.state.content === 'confirmEmail') {
        return (
          <div className="profile-detail">
            <table className="table">
              <tbody>
                <tr>
                  <td>Enter Verification Code</td>
                  <td><input
                    type="password"
                    onChange={(e) => {
                                this.onVerificationCodeChange(e);
                            }}
                  /></td>
                </tr>
                <tr>
                  <td />
                  <td>
                    <Button onClick={this.verifyEmail} variant="raised" className="jr-btn bg-success text-white">Verify Email</Button>
                    <Button variant="raised" className="jr-btn bg-success text-white" onClick={this.resendVerification}>Resend
                                    verification code
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      }

      if (this.state.content === 'changeProfileImage') {
        return (
          <div className="profile-detail">
            <table className="table">
              <tbody>
                <tr>
                  <td>Upload Image</td>
                  <td><input type="file" id="file-chooser" /></td>
                </tr>
                <tr>
                  <td />
                  <td>
                    <Button
                      variant="raised"
                      className="jr-btn bg-success text-white"
                      id="upload-button"
                      onClick={() => {
                                    this.uploadProfileImage();
                                    }}
                    >Upload
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      }
    };


    render = () => {
      if (window.innerWidth < 992) {
        $('#profileImg').toggleClass('w-75').toggleClass('w-25');
      }

      return (
        <div className="profile-and-settings">
          <div className="d-block d-xl-none">
            <Drawer
              type="temporary"
              className="profile-sidebar"
              open={this.state.drawerState}
              onClose={this.onToggleDrawer.bind(this)}
            >
              {this.sideNavJSX()}
            </Drawer>
          </div>
          <IconButton
            className="d-block d-xl-none"
            aria-label="Menu"
            onClick={this.onToggleDrawer.bind(this)}
          >
            <i className="zmdi zmdi-menu text-white" />
          </IconButton>
          <div className="row">
            <div className="col-0 col-xl-block">
              <div className="d-none d-xl-block">
                {this.sideNavJSX()}
              </div>
            </div>
            <div className="col-xl-9">
              {this.content()}
            </div>
          </div>
          <NotificationContainer />
        </div>
      );
    };
}

const mapStateToProps = ({ profileInfo }) => {
  return {
    username: profileInfo.username,
    data: profileInfo.data,
    userAttributes: profileInfo.userAttributes,
    userData: profileInfo.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateUsername: (username) => {
      dispatch({ type: 'UPDATE_USERNAME', username });
    },
    signOut: () => {
      dispatch({ type: 'SIGN_OUT' });
    },
    updateVerifyEmailField: (data) => {
      dispatch({ type: 'UPDATE_EMAIL_VERIFY_FIELD', payload: data });
    },
    profileDetailsUpdate: (data) => {
      dispatch({ type: 'PROFILE_DETAILS_UPDATE', payload: data });
    },
    setDefaultTheme: () => {
      dispatch({ type: 'SET_DEFAULT_THEME' });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileAndSettings);



// WEBPACK FOOTER //
// ./app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js